import { Outlet } from 'react-router';

import CombinedProviders from './CombinedProviders';

export default function AppStateProvider() {
  return (
    <CombinedProviders>
      <Outlet />
    </CombinedProviders>
  );
}
